<div class="confirm-modal ig-modal toggle-features-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Is This a Client Account?</div>
        <p>{{account.account.userName}}:</p>
        <ig-row>
            <ig-spinner *ngIf="loading"></ig-spinner>
            <ig-col [xs]="12" [md]="6">
                <mat-slide-toggle *ngIf="!loading" [checked]="account.account.isClientAccount" (change)="toggleIsClientAccount()">
                    <ig-success-wrap #success [delay]="50" [hideAfter]="2000">
                        This is {{!account.account.isClientAccount ? 'NOT' : ''}} a client account
                    </ig-success-wrap>
                </mat-slide-toggle>
            </ig-col>
        </ig-row>

    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/toggle.is.client/toggle.is.client.modal.component.html